import { Component, ContentChildren, QueryList } from '@angular/core';
import { Data, RouterOutlet } from '@angular/router';
import { MuiTabsBase } from '../../core/mui-tabs-base';
import { tabAnimation } from '../../core/tab-animation';
import { MuiTabNavLinkDirective } from '../tab-nav-link/mui-tab-nav-link.directive';

@Component({
  selector: 'mui-tab-nav',
  templateUrl: './mui-tab-nav.component.html',
  animations: [tabAnimation]
})
export class MuiTabNav extends MuiTabsBase {
  @ContentChildren(MuiTabNavLinkDirective)
  tabs: QueryList<MuiTabNavLinkDirective> = new QueryList<MuiTabNavLinkDirective>();

  selectedTabIndex = 0;

  prepareRoute(outlet: RouterOutlet): Data {
    return outlet && outlet.activatedRouteData;
  }

  setActiveTab(i: number): void {
    this.selectedTabIndex = i;
  }
}
